import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kpis-admin',
  templateUrl: './kpis-admin.component.html',
  styleUrls: ['./kpis-admin.component.scss']
})
export class KpisAdminComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
